import { render, staticRenderFns } from "./Politicas-privacidad.vue?vue&type=template&id=36d065a2&"
import script from "./Politicas-privacidad.vue?vue&type=script&lang=ts&"
export * from "./Politicas-privacidad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports